import { msg } from "@lingui/core/macro";

/**
 * Page and section titles shared between route crumbs (`router.tsx`) and nav
 * menu labels (`nav-menu.ts`). Sharing one descriptor keeps the wording (and
 * thus the catalog entry and its translations) from diverging between the two.
 *
 * Where the menu intentionally words a title differently from the crumb, both
 * variants live here side by side so the difference is visible and deliberate.
 */
export const pageTitles = {
  // Patients list: the crumb says "Patients", the menu "List of Patients".
  patients: msg`Patients`,
  listOfPatients: msg`List of Patients`,
  addNewPatient: msg`Add new patient`,

  // Patient profile sections
  trends: msg`Trends`,
  physicians: msg`Physicians`,
  alerts: msg`Alerts`,
  lvfp: msg`LVFP`,
  dri: msg`DRI`,
  afib: msg`AFib`,
  vitals: msg`Vitals`,
  symptoms: msg`Symptoms`,
  events: msg`Events`,
  thresholds: msg`Thresholds`,
  medications: msg`Medications`,
  comorbidities: msg`Comorbidities`,
  labs: msg`Labs`,
  exams: msg`Exams`,
  basicMedicalData: msg`Basic medical data`,
  ppgData: msg`PPG data`,
  ecgData: msg`ECG data`,
  addAnyData: msg`Add any data`,
  healthProReporting: msg`HealthPro reporting`,
  medicalReports: msg`Medical reports`,
  logs: msg`Logs`,
  questionnaires: msg`Questionnaires`,

  // Top-level pages
  medWaitingRoom: msg`Med waiting room`,
  techWaitingRoom: msg`Tech waiting room`,
  auditRoom: msg`Audit room`,
  dailyMonitoring: msg`Daily Monitoring`,
  calendar: msg`Calendar`,

  // Clinical studies
  clinicalStudies: msg`Clinical studies`,
  definition: msg`Definition`,
  overview: msg`Overview`,

  // Admin: the crumb says "CLV management", the menu "Admin".
  clvManagement: msg`CLV management`,
  admin: msg`Admin`,
  clinics: msg`Clinics`,
  users: msg`Users`,
  monitoringManagement: msg`Monitoring management`,
  accessPolicies: msg`Access policies`,
  accessLimiters: msg`Access limiters`,
  analytics: msg`Analytics`,
  settings: msg`Settings`,
  monitoring: msg`Monitoring`,
  consents: msg`Consents`,
};
